import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, BooleanDecoder, EnumDecoder, IntegerDecoder, StringDecoder, field } from '@simonbackx/simple-encoding';
import { v4 as uuidv4 } from 'uuid';
import { PermissionRoleForResponsibility } from './PermissionRole.js';
import { ResourcePermissions } from './ResourcePermissions.js';
import { PermissionLevel } from './PermissionLevel.js';
import { PermissionsResourceType } from './PermissionsResourceType.js';
export class MemberResponsibility extends AutoEncoder {
    id;
    name = '';
    description = '';
    minimumMembers = null;
    maximumMembers = null;
    /**
     * Whether this is a national responsibility or not
     */
    organizationBased = true;
    /**
     * Limit this responsibility to specific organizations
     */
    organizationTagIds = null;
    /**
     * Whether this responsibility should be assigned to a specific group (or more) of a specific organization
     */
    defaultAgeGroupIds = null;
    /**
     * Automatically grant the following permissions
     */
    permissions = null;
    /**
     * Automatically grant limited permissions to the group associated with this responsibility
     */
    groupPermissionLevel = PermissionLevel.None;
    get isGroupBased() {
        return this.defaultAgeGroupIds !== null;
    }
    compress() {
        this.permissions?.compress();
    }
    createDefaultPermissions(group) {
        return PermissionRoleForResponsibility.create({
            name: this.name + (group ? ` van ${group.settings.name.toString()}` : ''),
            responsibilityId: this.id,
            responsibilityGroupId: group?.id ?? null,
        });
    }
    getPermissions(groupId) {
        const r = this.permissions?.clone() ?? PermissionRoleForResponsibility.create({
            id: this.id,
            name: this.name,
            level: PermissionLevel.None,
            responsibilityId: this.id,
            responsibilityGroupId: groupId,
            resources: new Map(),
        });
        r.name = this.name;
        r.id = this.id + (groupId ? '-' + groupId : '');
        r.responsibilityId = this.id;
        r.responsibilityGroupId = groupId;
        if (groupId && this.groupPermissionLevel !== PermissionLevel.None) {
            const map = new Map();
            map.set(groupId, ResourcePermissions.create({ level: this.groupPermissionLevel }));
            r.resources.set(PermissionsResourceType.Groups, map);
        }
        return r;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], MemberResponsibility.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberResponsibility.prototype, "name", void 0);
__decorate([
    field({ decoder: StringDecoder })
], MemberResponsibility.prototype, "description", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], MemberResponsibility.prototype, "minimumMembers", void 0);
__decorate([
    field({ decoder: IntegerDecoder, nullable: true })
], MemberResponsibility.prototype, "maximumMembers", void 0);
__decorate([
    field({ decoder: BooleanDecoder, optional: true })
], MemberResponsibility.prototype, "organizationBased", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), nullable: true, version: 273 })
], MemberResponsibility.prototype, "organizationTagIds", void 0);
__decorate([
    field({ decoder: new ArrayDecoder(StringDecoder), nullable: true, version: 273 })
], MemberResponsibility.prototype, "defaultAgeGroupIds", void 0);
__decorate([
    field({ decoder: PermissionRoleForResponsibility, nullable: true, version: 279 })
], MemberResponsibility.prototype, "permissions", void 0);
__decorate([
    field({ decoder: new EnumDecoder(PermissionLevel), version: 279 })
], MemberResponsibility.prototype, "groupPermissionLevel", void 0);
export class PlatformResponsibility extends MemberResponsibility {
}
//# sourceMappingURL=MemberResponsibility.js.map